import { useEffect, useState } from 'react';
import { Alert, Button, Form, Input, Modal, Tabs, Typography, message } from 'antd';
import { PermissionControl, usePermissions } from '../../permissions/access';
import { saveRecommendationTranslation } from '../../api/recommendations';
import { showRequestError } from '../../utils/request-feedback';

export const translationLanguages = [
    { key: 'zh-CN', label: '简体中文' }, { key: 'zh-TW', label: '繁體中文' },
    { key: 'ja', label: '日本語' }, { key: 'th', label: 'ไทย' }, { key: 'ar', label: 'العربية' },
];

export default function RecommendationTranslations({ target, onClose, onSaved }) {
    const [form] = Form.useForm();
    const { can } = usePermissions();
    const [language, setLanguage] = useState('zh-CN');
    const [saving, setSaving] = useState(false);
    useEffect(() => {
        if (!target) return;
        form.resetFields();
        form.setFieldsValue(target.translations || {});
        setLanguage('zh-CN');
    }, [target, form]);

    const save = async () => {
        if (saving || !target || !can('airecommendations.editTranslation')) return;
        let values;
        try { values = await form.validateFields([language]); }
        catch { return; }
        setSaving(true);
        try {
            await saveRecommendationTranslation({
                kind: target.kind, questionId: target.questionId || '0',
                sourceText: target.sourceText, lang: language, translatedText: values[language].trim(),
            });
            message.success('译文已保存');
            onSaved();
        } catch (error) { showRequestError(error); }
        finally { setSaving(false); }
    };
    return <Modal title={target?.kind === 'tag' ? 'Tag 多语言译文' : '问题多语言译文'} open={Boolean(target)} forceRender
        width={820} style={{ top: 24 }} styles={{ body: { maxHeight: 'calc(100vh - 200px)', overflowY: 'auto' } }}
        onCancel={() => { if (!saving) onClose(); }} closable={!saving} maskClosable={!saving} keyboard={!saving}
        footer={<>
            <Button onClick={onClose} disabled={saving}>关闭</Button>
            <PermissionControl permission="airecommendations.editTranslation"><Button type="primary" onClick={save} loading={saving}>保存当前语言</Button></PermissionControl>
        </>}>
        <Typography.Text type="secondary">英文原文</Typography.Text>
        <Typography.Paragraph style={{ whiteSpace: 'pre-wrap' }}>{target?.sourceText}</Typography.Paragraph>
        <Alert type="info" showIcon message="单独保存只更新当前语言。使用“翻译全部译文”或“翻译全部 Tag”重译时，会覆盖对应类型的五种语言记录，包括手动修订；执行前会提示确认。" style={{ marginBottom: 16 }} />
        <Form form={form} layout="vertical" disabled={saving || !can('airecommendations.editTranslation')}>
            <Tabs activeKey={language} onChange={value => { if (!saving) setLanguage(value); }} items={translationLanguages.map(item => ({
                ...item,
                children: <Form.Item name={item.key} label={`${item.label}译文`} rules={[{ required: true, whitespace: true, message: '请填写译文' }]}>
                    <Input.TextArea rows={8} maxLength={40000} showCount dir={item.key === 'ar' ? 'rtl' : 'auto'} />
                </Form.Item>,
            }))} />
        </Form>
    </Modal>;
}
